export default function appViewerMenuIsOpen(state) {
  return state.appViewerMenuIsOpen;
}
